import { Label } from "@/components/ui/label";

export const AgentPicker = ({ agents, value, onChange, testId }) => (
  <div>
    <Label className="text-xs">Surety agent who gets the lead(s) *</Label>
    <select className="h-9 w-full rounded-md border border-slate-200 bg-white px-2 text-sm" value={value}
      onChange={(e) => onChange(e.target.value)} data-testid={testId}>
      <option value="">Choose an agent</option>
      {agents.map((a) => <option key={a.id} value={a.id}>{a.first_name} {a.last_name} ({a.email})</option>)}
    </select>
  </div>
);
